// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__pimE1","input-label":"FormInput_input-label__-5xis"};